<template>
  <div class="work-container">
    <el-row>
      <el-col>
        <el-row class="tcf-row">
          <el-col class="card">
            <div class="card-body">
              <div class="menu-list" v-for="(m,index) in topMenu" :key="'t'+index">
                <div class="menu-title">{{m.name}}</div>
                <div class="menu-item">
                  <template v-for="menu in m.menu">
                    <a v-if="menu.link" :href="menu.link" target="_blank" class="menu-li">
                      <div class="menu-item-img" :style="'background-image:url('+menu.img+')'"></div>
                      <p class="menu-item-name">{{menu.name}}</p>
                    </a>
                    <router-link v-else :to="'/work/'+menu.num" class="menu-li" >
                      <div class="menu-item-img" :style="'background-image:url('+menu.img+')'"></div>
                      <!-- <div :ref="menu.num+'msg'" class="el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge">0</div> -->
                      <p class="menu-item-name">{{menu.name}}</p>
                    </router-link>
                  </template>
                </div>
              </div>
              <div class="menu-list" v-for="(m,index) in workMenu" :key="index">
                <div class="menu-title">{{m.name}}</div>
                <div class="menu-item">
                  <template v-for="menu in m.menu">
                    <a v-if="menu.link" :href="menu.link" target="_blank" class="menu-li">
                      <div class="menu-item-img" :style="'background-image:url('+menu.img+')'"></div>
                      <p class="menu-item-name">{{menu.name}}</p>
                    </a>
                    <router-link v-else :to="'/work/'+menu.num" :style="menu.use===9?'display: none':''" class="menu-li" >
                      <div class="menu-item-img" :style="'background-image:url('+menu.img+')'"></div>
                      <div :ref="menu.num+'msg'" class="el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge">0</div>
                      <p class="menu-item-name">{{menu.name}}</p>
                    </router-link>
                  </template>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getStaffUserMsgCountList, getDealerUserMsgCountList } from '@/api/work'
import { getFileKinds } from '@/api/archive'

export default {
  name: 'work',
  computed: {
    user: getUser
  },
  data() {
    return {
      workMenu: [],
      topMenu: [],
      refTimer: null
    }
  },
  created() {
    this.getRuleMenu()
    this.getTopMenu()
  },
  mounted() {
    if (this.user.rank === 0) {
      this.getStaffUserMsgCount()
      // if (this.refTimer === null) {
      //   this.refTimer = setInterval(this.getStaffUserMsgCount, 1000)
      // }
    } else {
      this.getDealerUserMsgCountList()
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === '/work') {
        if (this.user.rank === 0) {
          this.getStaffUserMsgCount()
        } else {
          this.getDealerUserMsgCountList()
        }
        // if (this.refTimer === null) {
        //   this.refTimer = setInterval(this.getStaffUserMsgCount, 1000)
        // }
      } else {
        // if (this.refTimer !== null) {
        //   clearInterval(this.refTimer)
        //   this.refTimer = null
        // }
      }
    }
  },
  methods: {
    getRuleMenu() {
      const roleMenu = JSON.parse(sessionStorage.getItem('ElichainUserRoleMenu'))
      if (roleMenu !== null && roleMenu !== undefined) {
        this.workMenu = roleMenu

        // this.workMenu.forEach(r => {
        //   if (r.name.indexOf('其他应用') > -1 || r.name.indexOf('学习管理') > -1) {
        //     // 额外的菜单
        //     let otherItem = {
        //       name: '乔金斯研习社',
        //       img: 'https://www.mulu.life/efile/upload/images/20210315/9335219c-ffe9-4529-ba31-a659f13a6b03.png',
        //       num: '',
        //       link: 'https://www.kujiale.com/pub/site/design-zone/3DGG0TQTVFGE/home',
        //       mid: 999999,
        //       use: 0
        //     };
        //     if (Array.isArray(r.menu)) {
        //       // r.menu.push(otherItem);
        //     }
        //   }
        // });
      }
    },
    getTopMenu() {
      this.topMenu = [];

      let aboutItem = {name: '关于乔金斯', menu: [{
        name: '品牌简介',
        img: 'https://www.mulu.life/efile/upload/images/20210313/a5a4313a-1236-49f7-b54c-e6b95c34d738.png',
        num: '',
        link: 'https://elichain.oss-cn-hangzhou.aliyuncs.com/jokins/%E4%B9%94%E9%87%91%E6%96%AF%E5%93%81%E7%89%8C%E7%AE%80%E4%BB%8B%E3%80%902026%E7%89%88%E3%80%91.pdf',
        mid: 1111111,
        use: 0
      }, {
        name: '品牌白皮书',
        img: 'https://www.mulu.life/efile/upload/images/20210313/3225d896-3e51-4935-9a44-5228ebf3c396.png',
        num: '',
        link: 'https://elichain.oss-cn-hangzhou.aliyuncs.com/jokins/%E4%B9%94%E9%87%91%E6%96%AF%E7%99%BD%E7%9A%AE%E4%B9%A6%282025.08.09%29.pdf',
        mid: 1111112,
        use: 0
      }, {
        name: '供应链手册',
        img: 'https://www.mulu.life/efile/upload/images/20210313/b052d5af-999b-4022-b96d-426f7efdf7c6.png',
        num: '',
        link: 'https://elichain.oss-cn-hangzhou.aliyuncs.com/jokins/%E4%B9%94%E9%87%91%E6%96%AF%E5%93%81%E7%89%8C%E4%BE%9B%E5%BA%94%E9%93%BE%E6%89%8B%E5%86%8C2026.pdf',
        mid: 1111113,
        use: 0
      }]};
      this.topMenu.push(aboutItem);

      // console.log(this.workMenu)
      let quotationMenu = [];
      const index = this.workMenu.findIndex(r => r.name.indexOf('报价书') > -1);
      if (index > -1) {
        const menus = this.workMenu[index].menu || [];
        quotationMenu.push(...menus);
        this.workMenu = this.workMenu.filter(r => r.name.indexOf('报价书') === -1);
      }
      let quotationItem = {name: '报价书', menu: [...quotationMenu, {
        name: '查看报价书',
        img: 'https://www.mulu.life/efile/upload/images/20210313/45a88132-e223-4836-a004-271e0ed8cacb.png',
        num: `offer-book/detail`,
        mid: 99999,
        use: 0
      }]};
      // console.log(quotationItem)
      // 经销商用户只有店主用户可以查看
      if (this.user.delid ? this.user.isMain == 1 : true) {
        this.topMenu.push(quotationItem);
      }
      getFileKinds({}).then(response => {
        let fileKinds = response.data || []
        if (fileKinds.length > 0) {
          let studyItem = null
          let menus = []
          fileKinds.forEach(r => {
            const item = {
              name: r.name,
              img: r.icon || 'https://www.mulu.life/efile/upload/images/20210315/a0f50ccb-6aa7-4dc4-b12e-8e10138aee47.png',
              num: `archive/${r.id}?directory=0`,
              mid: r.id,
              use: 0
            };
            if (r.name.indexOf('商学院') > -1) {
              studyItem = item;
              return
            }
            menus.push(item);
          });
          this.topMenu.push({ name: '数字化档案', menu: menus });
          if (studyItem) {
            let has_study_role = false
            this.workMenu.forEach(r => {
              if (r.name.indexOf('学习管理') > -1) {
                has_study_role = true
                if (!Array.isArray(r.menu)) {
                  r.menu = [];
                }
                r.menu.push(studyItem);
              }
            });
            // 无权限默认添加
            if (!has_study_role) {
              this.topMenu.push({ name: '学习管理', menu: [studyItem] });
            }
          }
        }
      }).catch(() => {})
    },
    getStaffUserMsgCount() {
      const data = {
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role
      }
      getStaffUserMsgCountList(data).then(response => {
        for (let w of this.workMenu) {
          for (let menu of w.menu) {
            let dom = this.$refs[`${menu.num}msg`][0]
            let ishave = false
            for (let m of response.data) {
              if (menu.num === m.num) {
                dom.innerHTML = m.count > 99 ? '99+' : m.count
                if (m.count > 0) {
                  dom.className = 'el-badge__content el-badge__content--undefined is-fixed menu-badge'
                } else {
                  dom.className = 'el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge'
                }
                ishave = true
                break
              }
            }
            if (!ishave) {
              dom.className = 'el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge'
            }
          }
        }
      })
    },
    getDealerUserMsgCountList() {
      const data = {
        delid: this.user.delid,
        userid: this.user.userid
      }
      getDealerUserMsgCountList(data).then(response => {
        for (let w of this.workMenu) {
          for (let menu of w.menu) {
            let dom = this.$refs[`${menu.num}msg`][0]
            let ishave = false
            for (let m of response.data) {
              if (menu.num === m.num) {
                dom.innerHTML = m.count > 99 ? '99+' : m.count
                if (m.count > 0) {
                  dom.className = 'el-badge__content el-badge__content--undefined is-fixed menu-badge'
                } else {
                  dom.className = 'el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge'
                }
                ishave = true
                break
              }
            }
            if (!ishave) {
              dom.className = 'el-badge__content el-badge__content--undefined is-fixed menu-badge hide-badge'
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.work-container {
  .tcf-row{
    .card{
      .card-body{
        .menu-list{
          width: 100%;
          position: relative;
          margin-bottom: 10px;
          .menu-title{
            width: 100%;
            font-size: 14px;
            font-weight: 500;
            margin-top: 10px;
            color: #404852;
          }
          .menu-item{
            list-style: none;
            width: 100%;
            margin: 0;
            padding:20px 0;
            position: relative;
            .menu-li{
              display: -webkit-flex;
              display: -ms-flexbox;
              display: flex;
              -webkit-flex-direction: column;
              -ms-flex-direction: column;
              flex-direction: column;
              -webkit-align-items: center;
              -ms-flex-align: center;
              align-items: center;
              -webkit-justify-content: space-between;
              -ms-flex-pack: justify;
              justify-content: space-between;
              width: 104px;
              margin: 4px 0 10px;
              float: left;
              border-radius: 2px;
              cursor: pointer;
              position: relative;
              .menu-item-img{
                width: 60px;
                height: 60px;
                margin-top: 10px;
                //border: 1px solid #f0f0f0;
                //box-shadow: 0 2px 8px rgba(56,56,56,0.06);
                transition: margin-top 218ms;
                background-size: cover;
                background-repeat: no-repeat;
                border-radius: 6px;
              }
              .menu-item-name{
                width: 100%;
                text-align: center;
                line-height: 24px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 0 0 5px 0;
                font-weight: 400;
                color: #606266;
                font-size: 13px;
                font-weight: bold;
              }
              &:hover{
                background: #f5f7fa;
                .menu-item-name{
                  color:#409EFF;
                }
              }
            }
            &:after{
              content: ' ';
              clear: both;
              display: table;
            }
          }
          &:last-child{
            margin-bottom: 0;
          }
        }
        .date-title{
          margin-top: 20px;
          font-weight: 400;
          span{
            color:#4385f7;
            font-size: 20px;
            margin: 0 6px;
          }
          .my-schedule{
            margin-top: 6px;
            font-size: 14px;
            color:#404852;
            font-weight: 400;
            &:hover{
              color:#409EFF;
            }
          }
        }
        .work-banner{
          height: 120px;
          .banner-item{
            border-radius: 2px;
            width: 100%;
            height: 120px;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
}
</style>
